module.exports = __webpack_public_path__ + "static/media/400334_02.35ea1e58.png";